import PrintFooter from './PrintFooter'
export default PrintFooter